import { render, staticRenderFns } from "./BaseStepByStep.vue?vue&type=template&id=45bf1988&scoped=true&"
import script from "./BaseStepByStep.vue?vue&type=script&lang=ts&"
export * from "./BaseStepByStep.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStepByStep.vue?vue&type=style&index=0&id=45bf1988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bf1988",
  null
  
)

export default component.exports